"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageTagParser = void 0;
/**
 * Used to extract information from an IETF language tag.
 */
class LanguageTagParser {
    /**
     * Determines and returns the language part of an IETF language tag.
     */
    static getLanguageFromLanguageTag(languageTag) {
        if (!languageTag)
            return undefined;
        const parts = languageTag.split('-');
        return parts.length >= 1 ? parts[0] : undefined;
    }
    /**
     * Determines and returns the country part of an IETF language tag.
     */
    static getCountryFromLanguageTag(languageTag) {
        if (!languageTag)
            return undefined;
        const parts = languageTag.split('-');
        return parts.length >= 2 ? parts[1] : undefined;
    }
}
exports.LanguageTagParser = LanguageTagParser;
//# sourceMappingURL=LanguageTagParser.js.map